export default "__VITE_ASSET__3462d3c8__"